'use client';

import { bindFirstPartyPath, bindPlatformUrl } from '../../shared/browser/boundUrlSet.ts';
import { InAppLink, type InAppLinkProps } from './InAppLink.tsx';

export interface PlatformLinkProps extends Omit<InAppLinkProps, 'href'> {
  /**
   * A code constant: one of this app's pages (`/terms`) or a fixed vendor
   * page. Never a value from props, the network or a model.
   * tests/ci/boundUrlBinders.test.ts requires a string literal here, or a
   * file it lists with the constant the value comes from.
   */
  href: string;
}

/**
 * An InAppLink to a page whose address is written in this bundle: legal
 * pages, help pages, vendor policy pages, credits. The address is bound as
 * code (boundUrlSet.ts), so it is a link everywhere, server-rendered pages
 * included, and opens like any InAppLink. A link to anything else, such as
 * an address in a message or a search result, uses InAppLink and stays
 * text until the server binds it.
 */
export function PlatformLink({ href, ...linkProps }: PlatformLinkProps) {
  const bound = href.startsWith('/') ? bindFirstPartyPath(href) : bindPlatformUrl(href);
  return <InAppLink {...linkProps} href={bound ?? href} />;
}

export default PlatformLink;
